import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchRYIVariants } from '../../redux/Models';
import { Helmet } from "react-helmet";
import { Formik, Form } from 'formik';
import { validate, defaultSchema } from '../../functions/validation';
import API from '../../functions/api';
import { gtmPageview, gtmPush } from '../../functions/gtm';
import Button from '../../audi-ui-components/Button';
import Modal from '../../audi-ui-components/Modal';
import Layout from '../../components/Layout';
import queryString from 'query-string';
import _find from 'lodash/find';
import SelectedVariants from './SelectedVariants';
import RYIForm from './RYIForm';
import Spinner from '../../audi-ui-components/Spinner';
import { prefCentreService } from '../../functions/apiRequestHelper';
import './UpcomingModels.scss';
import {
    PATH_UPCOMINGMODELS,
    PATH_UPCOMINGMODEL,
    PATH_UPCOMINGMODEL_DEALER,
    PATH_THANKS,
    UI_AUDI,
    DEFAULT_THEME,
} from '../../constants';

const mapStateToProps = state => {
    return {
        ryiVariants: state.models.ryiVariants || [],
        ryiIsLoading: typeof state.models.ryiVariants === "undefined",
        ryiPreSelectedVariant: state.models.ryiPreSelectedVariant
    };
}
const mapDispatchToProps = dispatch => {
    return {
        fetchRYIVariants: (v, ids) => {dispatch(fetchRYIVariants(v, ids));}
    }
}

const UpcomingModels = ({ ryiVariants, ryiIsLoading, ryiPreSelectedVariant, ryiMetaTitle, ryiMetaDescription, fetchRYIVariants, match, location, history }) => {
  
    const query = queryString.parse(location.search);
    const theme = query.theme || DEFAULT_THEME;
    const _isLocked = Boolean(ryiPreSelectedVariant?.name && (match.path === `${PATH_UPCOMINGMODEL}/:variant?` || match.path === `${PATH_UPCOMINGMODEL_DEALER}/:variant?` || query.hidecarousel));
    const _isDealerContact = match.path === `${PATH_UPCOMINGMODEL_DEALER}/:variant?`;
    
    const [showForm, setShowForm] = useState(false);
    const [submittedData, setSubmittedData] = useState(null);
    const [serverError, setServerError] = useState(null);
    const [isLocked, setIsLocked] = useState(_isLocked);
    const [recordId, setRecordId] = useState(null);
    
    const initVals = {
        optIn: false,
        optOut: false,
        dealerContact: _isDealerContact,
        preferredContactMethod: "Email",
        planningToBuyCar: "",
        findDealerBy: "postcode"
    };
    const [initCar, setInitCar] = useState({
        variantIds: []
    });
    const [user, setUser] = useState({
        firstName: "",
        lastName: "",
        emailAddress: "",
        postCode: "",
        dealerPostcode: "",
        mobilePhone: "",
    });
    const [isFetchingUser, setIsFetchingUser] = useState(true);
    
    useEffect(() => {
      if (ryiPreSelectedVariant) {
        if (match.path === `${PATH_UPCOMINGMODEL_DEALER}/:variant?` && ryiPreSelectedVariant.ryiStatus !== "SOP") {
          // not SOP, redirect
          history.push(`${PATH_UPCOMINGMODEL}/${match.params.variant}`);
        } else {
          setInitCar({variantIds: [ryiPreSelectedVariant.variantId]});
          setShowForm(true);
          if (match.path === `${PATH_UPCOMINGMODEL}/:variant?` || match.path === `${PATH_UPCOMINGMODEL_DEALER}/:variant?` || query.hidecarousel) {
            setIsLocked(true);
          }
        }
      }
    }, [ryiVariants, ryiPreSelectedVariant, match.path]);
    
    useEffect(() => {
      if (!ryiVariants || ryiVariants.length === 0) {
        fetchRYIVariants(match.params.variant, query.v?.split(","));
      }
      if (query.sfid) {
          prefCentreService.get(query.sfid).then((result) => {
            setUser({
              firstName: result.firstName || "", lastName: result.lastName || "",
              emailAddress: result.email || "", mobilePhone: result.mobile || "",
              postCode: result.postcode || "", dealerPostcode: result.postcode || ""
            });
            setIsFetchingUser(false);
          }).catch((error) => {
            console.error('user error', error);
            setIsFetchingUser(false);
          });
      } else {
        setIsFetchingUser(false);
      }
      gtmPageview(match.url);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    useEffect(() => {
      if (ryiVariants.length > 0 && (match.path === `${PATH_UPCOMINGMODEL_DEALER}/:variant?` || match.path === `${PATH_UPCOMINGMODEL}/:variant?`) && !ryiPreSelectedVariant) {
        history.push(`${PATH_UPCOMINGMODELS}`);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ryiVariants.length])
    
    const scrollToError = () => {
      setTimeout(() => {
        let el = document.querySelector(".is-invalid");
        if (el) {
          el.scrollIntoView({behavior: "smooth", block: "center"});
        }
      }, 1000);
    }

    const validateForm = (values) => {
        var schema = {
            firstName: defaultSchema.firstName,
            lastName: defaultSchema.lastName,
            emailAddress: defaultSchema.emailAddress,
            postCode: defaultSchema.postCode,
            variantIds: {
                length: {
                    minimum: 1,
                    message: "Please select a model"
                }
            },
            optIn: {
                truthy: {
                    message: "This field is required"
                }
            }
        };
        if (values.dealerContact) {
          schema.dealerName = defaultSchema.dealerName;
          schema.preferredContactMethod = defaultSchema.preferredContactMethod;
          schema.planningToBuyCar = defaultSchema.planningToBuyCar;
          if (values.preferredContactMethod && (values.preferredContactMethod.indexOf("Phone") > -1 || values.preferredContactMethod.indexOf("SMS") > -1)) {
              schema.mobilePhone = defaultSchema.mobilePhone;
          }
        }
        var v = validate(values, schema, {format: "firstError", fullMessages: false});
        return v;
    }

    const handleSubmit = (values, formikProps) => {
        // console.log("handleSubmit");
        setServerError(null);
        let modelVariants = [];
        for (let i=0; i<values.variantIds.length; i++) {
          let id = values.variantIds[i];
          let variant = _find(ryiVariants, {variantId: id});
          modelVariants.push(variant);
        }
        let modelVariantNames = modelVariants.map((e) => e.name ).join("|");
        let { dealer, variantIds, ...payloadValues } = values;
        var payload = Object.assign({}, payloadValues, {modelVariants, modelVariantNames});
        if (process.env.RAZZLE_APP_ENV !== "local" || payload.submitToBackend) {
            gtmPush("form", "formSubmit", "registerYourInterest", payload);
            return API({
              method: /*recordId ? "PATCH" : */"POST",
              url: /*recordId ? `${process.env.RAZZLE_API_HOST}/1/form/${recordId}` : */`${process.env.RAZZLE_API_HOST}/1/form`,
              data: {formName: 'registerYourInterest', payload, variation: 1}
            }).then((result) => {
                window.scrollTo(0,0);
                gtmPush("form", "formSubmitSuccess", "registerYourInterest", payload);
                setSubmittedData(payload);
                if (result.data?.id) { setRecordId(result.data?.id); }
                formikProps.setSubmitting(false);
                gtmPageview(`${PATH_UPCOMINGMODELS}${PATH_THANKS}`);
            }).catch((error) => {
                // console.error(error);
                // window.scrollTo(0,0);
                formikProps.setSubmitting(false);
                gtmPush("form", "formSubmitError", "registerYourInterest", payload);
                let msg = "An error has occured";
                let errors = {};
                if (error.response?.data) {
                    if (error.response.data.modelState) {
                        for (let key in error.response.data.modelState) {
                            if (!Object.hasOwnProperty(key)) {
                                errors[key] = error.response.data.modelState[key][0];
                            }
                        }
                        msg = "There was a problem with the information you submitted, check the fields above for errors.";
                    } else {
                        msg = error.response.data.message || "An error has occured";
                    }
                }
                errors.submit = msg;
                formikProps.setErrors(errors);
                scrollToError();
            });
        } else {
            // fake submit for frontend testing
            console.log(payload);
            setSubmittedData(payload);
            setRecordId("test");
            formikProps.setSubmitting(false);
        }
    }
    
    return (
        <Layout ui={query.ui || UI_AUDI} theme={query.theme} embedded={query.embedded}>
            <Helmet>
                <title>{ryiPreSelectedVariant?.name ? `Upcoming Model - ${ryiPreSelectedVariant.name}` : "Upcoming Models"} | Audi Australia</title>
                <meta name="description" content={ryiPreSelectedVariant?.metaDescription ? ryiPreSelectedVariant.metaDescription : "Register your interest to receive exclusive updates before the arrival of all upcoming new models."} />
                <link rel="canonical" href="https://forms.audi.com.au/upcoming-models/" />
            </Helmet>
              
            <main className="audi-forms__page ryi">
                <div className="text-center mb-5 pt-3 pt-medium-5">
                  {!isLocked && <h1 className="aui-headline-2 mb-4 pt-3">Upcoming Models</h1>}
                  {!isLocked && <h4 className="aui-headline-4">Select models you're interested in</h4>}
                </div>
                
                {(ryiIsLoading || isFetchingUser) && <div style={{position:"relative", minHeight: "300px"}}><div className="spinner-wrapper"><Spinner isContinuous /></div></div>}

                {!(ryiIsLoading || isFetchingUser) && <Formik validate={validateForm} onSubmit={handleSubmit} initialValues={Object.assign({}, initVals, initCar, user)} enableReinitialize>
                  {({values, errors, touched, setValues, setFieldValue, setFieldTouched, isSubmitting, submitCount}) => (
                    <Form>
                    
                      {isLocked && <RYIForm
                        values={values} errors={errors} touched={touched} submitCount={submitCount} isSubmitting={isSubmitting}
                        setValues={setValues} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched}
                        ryiVariants={ryiVariants} query={query} scrollToError={scrollToError}
                        submittedData={submittedData}
                        isLocked
                        isPrefilled={user.emailAddress}
                        preSelectedVariant={ryiPreSelectedVariant}
                        theme={theme}
                      />}
                      
                      {!isLocked && <>
                        <SelectedVariants theme={query.theme} value={values.variantIds} options={ryiVariants} onChange={(v) => {
                          setFieldValue('variantIds', v);
                          setFieldTouched('variantIds');
                        }} />
                        <div className="ryi__step1-next py-3">
                          <div>
                            <p>Models Selected</p>
                            <p className="aui-font-extended ryi__selected-names">
                              {values.variantIds?.length > 1 && <>({values.variantIds.length}) </>}
                              <b>{values.variantIds?.map((id, i) => {
                                let variant = _find(ryiVariants, {variantId: id});
                                let comma = i < values.variantIds.length - 1 ? ", " : "";
                                return (<span key={`${variant.variandId}-${i}`}>{variant.name}{comma}</span>);
                              })}</b>
                            </p>
                          </div>
                          <div>
                            <Button variant="primary" theme={theme === "dark" ? "light" : null} onClick={()=>{ setShowForm(true); }} disabled={values.variantIds?.length === 0}>
                              Next
                            </Button>
                          </div>
                        </div>
                      
                        <Modal variant="layer" isActive={showForm && values.variantIds?.length > 0} closeButton close={()=>{ setShowForm(false); setSubmittedData(null); }}>
                          <div className="py-large-4 px-large-5">
                            
                            <RYIForm
                              values={values} errors={errors} touched={touched} submitCount={submitCount} isSubmitting={isSubmitting}
                              setValues={setValues} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched}
                              ryiVariants={ryiVariants} query={query} scrollToError={scrollToError}
                              submittedData={submittedData}
                              theme={theme}
                            />
                          </div>
                        </Modal>
                      </>}

                      <div className="aui-small">Overseas model with optional equipment shown. Australian model may differ.</div>
                      
                    </Form>
                  )}
                </Formik>}
            </main>
        </Layout>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(UpcomingModels);
